import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import {
  GetProfileService,
  GetProfileServicePlace,
  GetUserInsurance,
  GetUserInsuranceByDoctorId,
  GetUserServiceByDoctorId,
} from './index';

import {
  GetProfileServicePayload,
  GetProfileServicePlacePayload,
  GetProfileServicePlaceResponse,
  GetProfileServiceResponse,
  GetUserInsurancePayload,
  GetUserInsuranceResponse,
  GetUserServiceByDoctorIdPayload,
  GetUserServiceByDoctorIdResponse,
} from '@models/profile';

export const useGetProfileService = (
  payload: GetProfileServicePayload,
  options?: Omit<UseQueryOptions<GetProfileServiceResponse, Error>, 'queryKey'>,
): UseQueryResult<GetProfileServiceResponse, Error> => {
  return useQuery<GetProfileServiceResponse, Error>({
    queryKey: ['GetProfileService', payload],
    queryFn: () => GetProfileService(payload),
    ...options,
  });
};

export const useGetUserInsurance = (
  payload: GetUserInsurancePayload,
  options?: Omit<UseQueryOptions<GetUserInsuranceResponse, Error>, 'queryKey'>,
): UseQueryResult<GetUserInsuranceResponse, Error> => {
  return useQuery<GetUserInsuranceResponse, Error>({
    queryKey: ['GetUserInsurance', payload],
    queryFn: () => GetUserInsurance(payload),
    ...options,
  });
};

export const useProfileServicePlace = (
  payload: GetProfileServicePlacePayload,
  options?: Omit<
    UseQueryOptions<GetProfileServicePlaceResponse, Error>,
    'queryKey'
  >,
): UseQueryResult<GetProfileServicePlaceResponse, Error> => {
  return useQuery<GetProfileServicePlaceResponse, Error>({
    queryKey: ['GetProfileServicePlace', payload],
    queryFn: () => GetProfileServicePlace(payload),
    ...options,
  });
};

export const useGetUserInsuranceByDoctorId = (
  payload: GetUserInsurancePayload,
  options?: Omit<UseQueryOptions<GetUserInsuranceResponse, Error>, 'queryKey'>,
): UseQueryResult<GetUserInsuranceResponse, Error> => {
  return useQuery<GetUserInsuranceResponse, Error>({
    queryKey: ['GetUserInsuranceByDoctorId', payload],
    queryFn: () => GetUserInsuranceByDoctorId(payload),
    ...options,
  });
};

export const useGetUserServiceByDoctorId = (
  payload: GetUserServiceByDoctorIdPayload,
  options?: Omit<
    UseQueryOptions<GetUserServiceByDoctorIdResponse, Error>,
    'queryKey'
  >,
): UseQueryResult<GetUserServiceByDoctorIdResponse, Error> => {
  return useQuery<GetUserServiceByDoctorIdResponse, Error>({
    queryKey: ['GetUserServiceByDoctorId', payload],
    queryFn: () => GetUserServiceByDoctorId(payload),
    ...options,
  });
};
